import styles from "@website/icons/material/material.module.scss";
import { MaterialIconPropertiesType } from "@website/icons/material/material.types";
import { deepCompare } from "@website/utils/deep-compare";
import omit from "lodash-es/omit";
import { FC, memo } from "react";

const MaterialIconComponent: FC<MaterialIconPropertiesType> = (properties) => {
  const { className, name, variant, datatestid } = properties;
  return (
    <span
      className={`${styles["icon"]} ${styles[variant || "fill"]} ${
        className ?? ""
      }`}
      data-nosnippet
      data-testid={datatestid}
      {...omit(properties, "name", "className", "variant")}
    >
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        typeof jest === "object" && typeof test === "function" ? "" : name
      }
    </span>
  );
};

export const MaterialIcon = memo(MaterialIconComponent, deepCompare);
